import { lazy } from "react";
const ReportAllList = lazy(() => import("@/pages/system-directory/report-all/ReportAllList"));
const MyFavouriteList = lazy(() => import("@/pages/system-directory/my-favourite/MyFavouriteList"));
const MyTracksList = lazy(() => import("@/pages/system-directory/my-tracks/MyTracksList"));
const systemDirectoryRoute = [
  {
    path: "/reportAllList",
    name: "报表大全",
    component: ReportAllList,
    menuUrl: "/reportAllList"
  },
  {
    path: "/myFavourite",
    name: "我的收藏",
    component: MyFavouriteList,
    menuUrl: "/myFavourite"
  },
  {
    path: "/myTracks",
    name: "我的足迹",
    component: MyTracksList,
    menuUrl: "/myTracks"
  },
];
export default systemDirectoryRoute;